export default {
  signIn: 'Conectare',
  signOut: 'Deconectare',
  points: 'puncte',
  hyattSignInButton: 'Conectează-te la World of Hyatt',
};
